import { useContext } from 'react';

import PartnerContext from '../contexts/PartnerContext';

const useCurrentPartner = () => useContext(PartnerContext);

export default useCurrentPartner;
